export default "__VITE_ASSET__BzO2Q0k4__"